import styled from "@emotion/styled/macro";
import {
  Banner,
  BannerTypes,
  Modal,
  tokens,
  Typography,
} from "@sunrun/experience-ui-components";
import { Box } from "components/atoms/Box";

type SharePresentationModalProps = {
  onClose: () => void;
  onSend: () => void;
  isSending: boolean;
  customerName: string;
  customerEmail: string;
};

const SharePresentationModal = ({
  onClose,
  onSend,
  isSending,
  customerName,
  customerEmail,
}: SharePresentationModalProps) => {
  return (
    <CustomModal
      title="Share final design presentation"
      hideIcon
      testId="cap-share-presentation-modal"
      primaryButton={{
        text: "Share by email & messages",
        disabled: isSending,
        onClick: () => onSend(),
      }}
      secondaryButton={{
        text: "Cancel",
        disabled: false,
        onClick: () => onClose(),
      }}
      onClose={() => onClose()}
    >
      <Banner show bannerType={BannerTypes.InfoLight} showClose={false}>
        {customerName} should download the Sunrun Customer App to receive & send
        messages, view their final design, and track their project.
      </Banner>
      <Box marginBottom="24px" marginTop="24px">
        <Typography>
          Share the final design presentation by email and messages.
        </Typography>
      </Box>
      <ContactInfo>
        <Typography>{customerName}</Typography>
        <Typography color={tokens.TINTS_OFF_WHITE_20}>
          {customerEmail}
        </Typography>
      </ContactInfo>
    </CustomModal>
  );
};

const CustomModal = styled(Modal)`
  .modal-container {
    width: 80%;
    max-width: 820px;
  }

  .modal-content-header {
    padding: 40px 40px 32px 40px;
  }
  .modal-content-container {
    overflow-y: unset;
    padding: 0px 40px;
  }
`;

const ContactInfo = styled(Box)`
  display: flex;
  padding: 20px 24px;

  gap: 16px;
  align-items: flex-start;

  border-radius: 8px;
  border: 1px solid ${tokens.BORDER_LIGHT};
  background: ${tokens.TINTS_OFF_WHITE_80};
`;

export { SharePresentationModal };
